import React, {useCallback, useState} from 'react'

import {useFetchBoundCard, useFetchCards} from '../../shared/hooks'
import {PaymentCard} from '../../shared/types'
import {CardListFormModal} from '../../shared/ui'
import {CardAddModal} from '../card-add-modal'
import {CardListModalProps} from './CardListModal.types'

const CardListModal: React.FC<CardListModalProps> = ({scope, onSuccess, onError, onClose}) => {
  const {cardsPayload, isCardsPending, fetchCardsHandler} = useFetchCards(scope)
  const {fetchBoundCardHandler, isBoundCardPending} = useFetchBoundCard()
  const [isCardAddModalOpened, setIsCardAddModalOpened] = useState(false)

  const toggleCardAddModal = useCallback(() => {
    setIsCardAddModalOpened(prevState => !prevState)
  }, [])

  const boundCardHandler = useCallback(
    (card: PaymentCard) => {
      fetchBoundCardHandler(
        {
          card: {
            id: card.id,
          },
          scopes: [
            {
              kind: scope,
            },
          ],
        },
        {
          onSuccess,
          onError,
        },
      )
    },
    [fetchBoundCardHandler, onError, onSuccess, scope],
  )

  const successCardAddHandler = useCallback(() => {
    fetchCardsHandler()
    setIsCardAddModalOpened(false)
  }, [fetchCardsHandler])

  return (
    <React.Fragment>
      <CardListFormModal
        cards={cardsPayload?.cards}
        isCardBounding={isBoundCardPending}
        isCardsPending={isCardsPending}
        onAddNewCard={toggleCardAddModal}
        onBound={boundCardHandler}
        onClose={onClose}
        selectedCard={cardsPayload?.card}
      />

      {isCardAddModalOpened && (
        <CardAddModal onClose={toggleCardAddModal} onSuccess={successCardAddHandler} scope={scope} />
      )}
    </React.Fragment>
  )
}

CardListModal.displayName = 'CardListModalWidget'

export default React.memo(CardListModal)
